import { t } from 'i18next';
import React from 'react';

const About = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6">
            <div className="row g-3">
              <div className="col-6 text-end">
                <img className="img-fluid bg-white w-100 mb-3 wow fadeIn" data-wow-delay="0.1s" src="img/about-1.png" alt="" />
                <img className="img-fluid bg-white w-50 wow fadeIn" data-wow-delay="0.2s" src="img/about-3.png" alt="" />
              </div>
              <div className="col-6">
                <img className="img-fluid bg-white w-50 mb-3 wow fadeIn" data-wow-delay="0.3s" src="img/about-4.png" alt="" />
                <img className="img-fluid bg-white w-100 wow fadeIn" data-wow-delay="0.4s" src="img/about-2.png" alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div className="section-title">
              <p className="fs-5 fw-medium fst-italic text-primary">{t('trusted_partner')}</p>
              <h6 className="fw-bold">{t('company_description')}</h6>
            </div>
            <div className="row g-3 mb-4">
              <div className="col-sm-4">
                <img className="img-fluid bg-white w-100" src="img/about-5.png" alt="" />
              </div>
              <div className="col-sm-8">
                <h5>{t('our_mission')}</h5>
                <p className="mb-0">{t('mission_description')}</p>
              </div>
            </div>
            <div className="border-top mb-4"></div>
            <div className="row g-3">
              <div className="col-sm-8">
                <h5>{t('our_vision')}</h5>
                <p className="mb-0">{t('vision_description')}</p>
              </div>
              <div className="col-sm-4">
                <img className="img-fluid bg-white w-100" src="img/about-6.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;